import { render } from "./UserCell.vue?vue&type=template&id=3c0131c0&scoped=true"
import script from "./UserCell.vue?vue&type=script&lang=js"
export * from "./UserCell.vue?vue&type=script&lang=js"

import "./UserCell.vue?vue&type=style&index=0&id=3c0131c0&lang=scss&scoped=true"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0131c0"]])

export default __exports__